import Grid from "@material-ui/core/Grid";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { instance } from "Actions/AxiosInstance";
import cycleDisabled from "Assets/Svg/payroll/cycle-disabled.svg";
import cycleDone from "Assets/Svg/payroll/cycle-done.svg";
import cyclePending from "Assets/Svg/payroll/cycle-pending.svg";
import runPayrollEmpty from "Assets/Svg/run-payroll-initial.svg";
import get from "lodash/get";
import sortBy from "lodash/sortBy";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { getOptArr } from "Utils/arr";
import { isIndateBeforeOutdate } from "Utils/dates";
import {
  setSaveProgress,
  removeSaveProgress,
} from "../../../Actions/SaveProgressAction";
import TabContainer from "../../../Component/Common/TabContainer";
import AnalysedData from "./AnalysedData";
import Drafts from "./Drafts";
import Overview from "./Overview";
import RunPayrollTab from "./RunPayrollTab";
import SalaryAdjustments from "./SalaryAdjustments";
import PayrollCompleted from "./PayrollCompleted";
import { bindActionCreators } from "redux";

const nextMonth = moment().format("YYYY-MM-DD");

const styles = () => ({
  drawerPaper: {
    width: 356,
  },
  tablehead: {
    background: "#f7f8f8",
  },
});

const specialCasesOptions = [
  { displayvalue: "52", displayname: "New employee (DOJ is of past month)", grouptypeid: 52 },
  { displayvalue: "100", displayname: "FNF employees", grouptypeid: 100 },
  { displayvalue: "51", displayname: "Postponed/Hold employees", grouptypeid: 51 },
  { displayvalue: "53", displayname: "Deleted payslip employees (From past month)", grouptypeid: 53 },
];

// const paymentTypesOptions = [
//   // { displayvalue: "60", displayname: "Fnf employees", grouptypeid: "60" },
//   { displayvalue: "60", displayname: "Cash", grouptypeid: "60" },
//   { displayvalue: "61", displayname: "Cheque", grouptypeid: "61" },
//   { displayvalue: "62", displayname: "Bank Transfer", grouptypeid: "62" },
// ];

const otherOptions = [
  { displayvalue: 1, displayname: "All employees", grouptypeid: 1 },
  { displayvalue: 0, displayname: "Specific employees", grouptypeid: 0 },
  { displayvalue: "100", displayname: "FNF employees", grouptypeid: 100 },
];


class RunPayroll extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabValue: 0,
      fromdate: "",
      sortmenu: false,
      sort_anchorEl: null,
      sortorder: 1,
      searchValue: "",
      unread: false,
      generated: false,
      page: "home", // home, analyse, salaryadjustment, payrolloverview, payrollCompleted
      currentview: "runpayrollview",
      payrollcycle: null,
      salarycycle: null,
      selectedOptions: [],
      selectedEmployees: [],
      selectedEmpType: [],
      selectedBus: [],
      selectedDep: [],
      selectedLoc: [],
      empList: [],
      specialEmps: [],
      normalEmps: [],
      alldrafts: [],
      postdataforemplist: null,
      isSpeicalCase: false,
      initdata: {},
      payrollcyclestart: null,
      payrollcycleend: null,
      filterOptions: [
        {
          label: "Generel types",
          options: otherOptions,
        },
        // {
        //   label: "Special cases",
        //   options: specialCasesOptions,
        // },
        // {
        //   label: "Payment types",
        //   options: paymentTypesOptions,
        // },
      ],
    };
    this.setCurrentView = this.setCurrentView.bind(this);
    this.getinitrunpayroll = this.getinitrunpayroll.bind(this);
    this.getsalarycycledata = this.getsalarycycledata.bind(this);
    this.updateSelection = this.updateSelection.bind(this);
    this.getallbunits = this.getallbunits.bind(this);
    this.getAllEmp = this.getAllEmp.bind(this);
    this.updateNormalEmps = this.updateNormalEmps.bind(this);
    this.updateSpecialEmps = this.updateSpecialEmps.bind(this);
    this.getalldepartments = this.getalldepartments.bind(this);
    this.getallemploymenttypes = this.getallemploymenttypes.bind(this);
    this.getalllocations = this.getalllocations.bind(this);
    this.setpostdataforemplist = this.setpostdataforemplist.bind(this);
    this.onSkip = this.onSkip.bind(this);
  }

  componentDidMount() {
    this.Init();
    this.getinitrunpayroll();
    this.getallbunits();
    this.getalldepartments();
    this.getallemploymenttypes();
    this.getalllocations();
    this.getAllEmp();
  }

  Init() {
    const data = {
      // featurekey: "planner_designation",
      offset: 0,
      limit: 50,
    };
    instance.post("payroll/initsalaryassigned", data).then((resp) => {
      this.setState({
        initdata: get(resp, "data.result[0]", {}),
      });
    });
  }

  getAllEmp() {
    const { login } = this.props;
    const data = {
      featurekey: "runpayroll",
      subscriptionid: login.subscriptionid,
    };
    instance
      .post(`subscription/getemployeelist`, data)
      .then((result) => {
        this.setState({
          empList: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getallbunits() {
    instance.get("subscription/allbusinessunitlist").then((resp) => {
      const darr = get(resp, "data.result", []).map((x) => ({
        ...x,
        grouptypeid: 2,
      }));
      this.setState({
        filterOptions: [
          ...this.state.filterOptions,
          {
            label: "Business Units",
            options: getOptArr({
              arr: darr,
              displaynamekey: "businessunitname",
              displayvaluekey: "businessunitid",

            }),
          },
        ],
      });
    }).catch((error) => {
      this.props.enqueueSnackbar(
        error.response ? error.response.data.error.message : error.message,
        { variant: "error" },
      );
    });
  }

  getalldepartments() {
    instance.get("subscription/alldepartmentlist").then((resp) => {
      const darr = get(resp, "data.result", []).map((x) => ({
        ...x,
        grouptypeid: 3,
      }));
      this.setState({
        filterOptions: [
          ...this.state.filterOptions,
          {
            label: "Departments",
            options: getOptArr({
              arr: darr,
              displaynamekey: "departmentname",
              displayvaluekey: "departmentid",
            }),
          },
        ],
      });
    }).catch((error) => {
      this.props.enqueueSnackbar(
        error.response ? error.response.data.error.message : error.message,
        { variant: "error" },
      );
    });
  }

  onSkip  = async(arrEmployee) => {
    const { isSpeicalCase, specialEmps, normalEmps } = this.state;
    if (isSpeicalCase) {
      specialEmps.filter((x) => !x.ispayslipgenerated).map(y => {
        const idx = arrEmployee.findIndex(x1 => x1.employeeid == y.employeeid);
        if (idx >= 0) {
          specialEmps.splice(idx, 1)
        }
      })
      this.setState({ specialEmps });
    } else {
      normalEmps.filter((x) => !x.ispayslipgenerated).map(y => {
        const idx = arrEmployee.findIndex(x1 => x1.employeeid == y.employeeid);
        if (idx >= 0) {
          normalEmps.splice(idx, 1)
        }
      })
      this.setState({ normalEmps });
    }
  }

  getallemploymenttypes() {
    instance.get("superuser/getmastercode/EmploymentType").then((resp) => {
      const darr = get(resp, "data.result", []).map((x) => ({
        ...x,
        grouptypeid: 4,
      }));
      this.setState({
        filterOptions: [
          ...this.state.filterOptions,
          { label: "Employement Types", options: darr },
        ],
      });
    }).catch((error) => {
      this.props.enqueueSnackbar(
        error.response ? error.response.data.error.message : error.message,
        { variant: "error" },
      );
    });
  }

  getalllocations() {
    const { login } = this.props;
    const data = {
      featurekey: "runpayroll",
      subscriptionid: login.subscriptionid,
    };
    instance
      .post(`subscription/allcompanylocation`, data).then((resp) => {
      const darr = get(resp, "data.result", []).map((x) => ({
        ...x,
        grouptypeid: 5,
      }));
      this.setState({
        filterOptions: [
          ...this.state.filterOptions,
          {
            label: "Locations",
            options: darr,
          },
        ],
      });
    }).catch((error) => {
      this.props.enqueueSnackbar(
        error.response ? error.response.data.error.message : error.message,
        { variant: "error" },
      );
    });
  }

  updateSelection({
    selectedOptions = this.state.selectedOptions,
    selectedEmployees = this.state.selectedEmployees,
    selectedBus,
    selectedDep,
    selectedEmpType,
    selectedLoc,
  }) {
    this.setState({
      selectedOptions,
      selectedEmployees,
      selectedBus,
      selectedDep,
      selectedEmpType,
      selectedLoc,
    });
  }

  setpostdataforemplist(postdataforemplist, fromdraft) {
    this.setState({ postdataforemplist, activeTabValue: fromdraft ? 0 : this.state.activeTabValue }, () => !fromdraft && this.setCurrentView("analyse"));
  }

  updateSpecialEmps(temp) {
    this.setState({
      specialEmps: temp,
    });
  }

  updateNormalEmps(temp) {
    this.setState({
      normalEmps: temp,
    });
  }

  getinitrunpayroll() {
    instance
      .get("payroll/initrunpayroll")
      .then((resp) => {
        const currentpayrollcycle = get(
          resp,
          "data.result",
          [],
        ).find((payroll) => payroll.payrollcycledurationid == this.props.match.params.pid);
        this.setState(
          {
            initrunpayroll: getOptArr({
              arr: get(resp, "data.result", "").filter((payroll) => payroll.payrollcycletypeid != 3),
              displayvaluekey: "payrollcycledurationid",
            }),
            payrollcycle: currentpayrollcycle,
            payrollcycledurationid: currentpayrollcycle ? currentpayrollcycle.payrollcycledurationid : null,
            payrollcyclestart: currentpayrollcycle ? currentpayrollcycle.payrollcyclestartdate : null,
            payrollcycleend: currentpayrollcycle ? currentpayrollcycle.payrollcycleenddate : null,
          },
          () => !this.state.salarycycledata && this.getsalarycycledata(),
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getsalarycycledata(payslipgenerateforallemp) {
    console.log('payslipgenerateforallemp: ', payslipgenerateforallemp);
    const { payrollcycledurationid } = this.state;
    if (!payrollcycledurationid) return;
    instance
      .get(`payroll/getsalarycycle/${payrollcycledurationid}`)
      .then((resp) => {
        const data = sortBy(get(resp, "data.result", []), "displayvalue");
        const findfirst = payslipgenerateforallemp == 1
          ? this.state.isSpeicalCase ? data.find((x) => x.displayvalue == this.props.match.params.id) : data.find((x) => !x.ispayrolldone)
          : data && data.find((x) => x.displayvalue == this.props.match.params.id);
        this.setState({
          salarycycledata: getOptArr({
            arr: data,
          }),
          isSpeicalCase: findfirst && findfirst.ispayrolldone,
          salarycycle: findfirst,
            // ? findfirst.ispayrolldone
            //   ? findfirst
            //   : get(data, `[${firstindex + 1}]`, null)
            // : null,
          salarycycleid: findfirst ? findfirst.salarycycleid : null,
            //   : get(data, `[${firstindex + 1}].salarycycleid`, null)
            // : null,
          salarycyclesplitid: findfirst ? findfirst.salarycyclesplitid : null,
          selectedOptions: payslipgenerateforallemp == 1 ? [] : this.state.selectedOptions,
          selectedEmployees: payslipgenerateforallemp == 1 ? [] : this.state.selectedEmployees,
          selectedBus: payslipgenerateforallemp == 1 ? [] : this.state.selectedBus,
          selectedDep: payslipgenerateforallemp == 1 ? [] : this.state.selectedDep,
          selectedEmpType: payslipgenerateforallemp == 1 ? [] : this.state.selectedEmpType,
          selectedLoc: payslipgenerateforallemp == 1 ? [] : this.state.selectedLoc,
          //     : get(data, `[${firstindex + 1}].salarycyclesplitid`, null)
          // : null,
        }, () => {
          if (!this.state.isSpeicalCase && !findfirst.ispayrolldone) {
            this.setState({
              page: "home",
            }, () => {
              // this.getalldrafts();
            });
          }
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  getalldrafts() {
    const { payrollcycledurationid, salarycycle } = this.state;
    const data = {
      payrollcycledurationid,
      salarycycleid: salarycycle.salarycycleid,
      salarycyclesplitid: salarycycle.displayvalue,
    };
    instance.post("payroll/draftpayroll", data).then((resp) => {
      this.setState({
        alldrafts: get(resp, "data.result[0].savedraft", []).filter((x) => x.generateddataid),
        activeTabValue: get(resp, "data.result[0].savedraft", []).filter((x) => x.generateddataid).length > 0 ? 1 : 0,
      });
    }).catch((error) => {
      this.props.enqueueSnackbar(
        error.response ? error.response.data.error.message : error.message,
        { variant: "error" },
      );
    });
  }

  handleTabChange = (e, activeTabValue) => {
    this.props.setSaveProgress(true);
    // this.props.history.push(MORE_OPTIONS[activeTabValue]);
    this.setState({ activeTabValue });
  };

  setCurrentView(value) {
    this.setState({ page: value });
  }

  handleClick = (event) => {
    (this.state.page == "home" || this.state.page == "payrolloverview") && this.state.activeTabValue == 0 && this.setState({ anchorEl: event.currentTarget, showcyclepopup: true });
  };

  handleClose = () => {
    this.setState({ showcyclepopup: false });
  };

  render() {
    const {
      activeTabValue,
      page,
      salarycycledata,
      salarycycle,
      payrollcycle,
      showcyclepopup,
      anchorEl,
      postdataforemplist,
      alldrafts = [],
      isSpeicalCase,
    } = this.state;
    const currentcycleindex = salarycycledata && salarycycledata.findIndex((x) => !x.ispayrolldone);
    return (
      <div className="innerwrapper-full-width">
        <div className="content-outer-wrapper">
          <div className="floatright">
            <Grid md="12" justify="flex-end">
              <div style={{ padding: 6 }} className="floatright">
                <div className="floatleft">
                  <div style={{ width: 600 }}>
                    {/* <div className={`floatright margin-left-8 ${this.state.page == "home" ? "cursour-pointer" : ""}`}> */}
                    <div className={`floatright margin-left-8 ${this.state.page == "home" || this.state.page == "payrolloverview" || activeTabValue == 0 ? "cursour-pointer" : ""}`}>
                      <p
                        className="normal-dark-secondary t-bold floatleft margin-right-8"
                        onClick={this.handleClick}
                      >
                        Salary cycle:
                      </p>
                      <p
                        className="normal-dark-secondary t-bold floatleft text-color-blue"
                        onClick={this.handleClick}
                      >
                        {salarycycle && salarycycle.displayname}
                      </p>
                      <Popover
                        open={showcyclepopup}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        onClose={this.handleClose}
                        className="margin-top-8"
                      >
                        <Grid container style={{ height: 300, width: 290 }}>
                          {salarycycledata
                            && salarycycledata.map((cycle, index) => (
                              <Grid
                                item
                                md="4"
                                style={{ height: 64, width: 64 }}
                                onClick={() => {
                                  (cycle.ispayrolldone
                                  || currentcycleindex == index)
                                  && this.setState({
                                    salarycycle: cycle,
                                    salarycycleid: cycle.salarycycleid,
                                    showcyclepopup: false,
                                    salarycyclesplitid: cycle.displayvalue,
                                    page: cycle.ispayrolldone ? "payrolloverview" : "home",
                                    isSpeicalCase: false,
                                    selectedOptions: [],
                                    selectedEmployees: [],
                                    selectedEmpType: [],
                                    selectedBus: [],
                                    selectedDep: [],
                                    selectedLoc: [],
                                    postdataforemplist: null,
                                  }, () => {
                                    // if (!this.state.isSpeicalCase) {
                                    //   this.getalldrafts();
                                    // }
                                  });
                                }}
                              >
                                <div className="padding8">
                                  <div
                                    style={{
                                      height: 40,
                                      width: 40,
                                      marginLeft: 20,
                                    }}
                                  >
                                    {/* <img
                                      src={
                                        !isIndateBeforeOutdate({
                                          indate: `${cycle.payrollyear}/${cycle.payrollmonthid}/01`,
                                          outdate: nextMonth,
                                        })
                                          ? cycleDisableddone
                                          ? cycleDone
                                          : cycle.ispayroll
                                          : cyclePending
                                      }
                                      className="height100 width100"
                                    /> */}
                                     <img
                                      src={!cycle.ispayrolldone && index > currentcycleindex
                                        ? cycleDisabled
                                        : cycle.ispayrolldone
                                        ? cycleDone
                                        : cyclePending
                                      }
                                      className="height100 width100"
                                    />
                                  </div>
                                  <div className="t-12 t-bold margin-top-4 text-align-center">
                                    {cycle.displayname}
                                  </div>
                                </div>
                              </Grid>
                            ))}
                        </Grid>
                      </Popover>
                    </div>

                    {/* <div className="floatright width40 margin-left-8 cursour-pointer">
                      <DynamicForm
                        fields={selectinputconverter({
                          value: payrollcycledurationid || null,
                          placeholder: "Select payroll cycle",
                          label: "",
                          options: initrunpayroll || [],
                        })}
                        onChange={(value) => {
                          this.setState(
                            { payrollcycledurationid: value },
                            () => {
                              this.getsalarycycledata();
                            },
                          );
                        }}
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </Grid>

            {/* <div className="floatleft">
              <DatePickerComponent
                start="Decade"
                depth="Year"
                max={new Date()}
                format={getEJ2CalenderDateFormat("mmm,YYYY")}
                value={this.state.fromdate}
                change={(e) => this.UpdateDate("fromdate", e)}
                allowEdit={false}
              />
            </div> */}
          </div>
          <div>
            {page == "home" && (
              <Grid container spacing={3}>
                <Grid item xs={12} md={7} sm={12} className="position-rel">
                  <div
                    className="width100"
                    style={{ position: "absolute", top: -52 }}
                  >
                    <div>
                      <Tabs
                        value={activeTabValue}
                        onChange={this.handleTabChange.bind(this)}
                        indicatorColor="#fff"
                        textColor="primary"
                        scrollButtons="auto"
                      >
                        <Tab
                          label="Run Payroll"
                          className={`tabheading ${
                            activeTabValue == 0
                              ? "active-tab1"
                              : "inactive-tab1"
                          } `}
                          disabled={activeTabValue === 1 && salarycycle && payrollcycle && alldrafts.length > 0}
                        />
                        {/* {!isSpeicalCase &&
                          <Tab
                          label="Saved Drafts"
                          className={`tabheading ${
                            activeTabValue == 1
                              ? "active-tab1"
                              : "inactive-tab1"
                          } `}
                        />} */}
                      </Tabs>
                      <div className="tab-border"></div>
                    </div>
                    <main>
                      <div>
                        {activeTabValue === 0 && (
                          <TabContainer>
                            <RunPayrollTab
                              {...this.props}
                              {...this.state}
                              filterOptions={this.state.isSpeicalCase
                                ? [{
                                    label: "Special case",
                                    options: specialCasesOptions,
                                  }]
                                : this.state.filterOptions
                              }
                              updateId={this.state.id}
                              updateSelection={this.updateSelection}
                              setCurrentView={this.setCurrentView}
                              setpostdataforemplist={this.setpostdataforemplist}
                              getsalarycycledata={this.getsalarycycledata}
                              updateSpecialEmps={this.updateSpecialEmps}
                              updateNormalEmps={this.updateNormalEmps}
                            />
                          </TabContainer>
                        )}
                        {!isSpeicalCase && activeTabValue === 1 && salarycycle && payrollcycle && alldrafts.length > 0 && (
                          <TabContainer>
                            <Drafts
                              {...this.props}
                              {...this.state}
                              postdataforemplist= {this.postdataforemplist}
                              updateId={this.state.id}
                              setCurrentView={this.setCurrentView}
                              updateSelection={this.updateSelection}
                              setpostdataforemplist={this.setpostdataforemplist}
                            />
                          </TabContainer>
                        )}
                      </div>
                    </main>
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={5}
                  sm={12}
                  className="display-flex"
                  style={{ flexDirection: "column", alignItems: "flex-end" }}
                >
                  <div className="clear-float margin-top-16">
                    <img src={runPayrollEmpty}></img>
                  </div>
                </Grid>
              </Grid>
            )}
            {page == "analyse"
              && salarycycle
              && payrollcycle
              && postdataforemplist && (
                <AnalysedData
                  setCurrentView={this.setCurrentView}
                  updateSelection={this.updateSelection}
                  onSkip={this.onSkip}
                  updateSpecialEmps={this.updateSpecialEmps}
                  updateNormalEmps={this.updateNormalEmps}
                  isSpeicalCase={this.state.isSpeicalCase}
                  {...this.state}
                  {...this.props}
                />
              )}
            {page == "salaryadjustment"
              && salarycycle
              && payrollcycle
              && postdataforemplist && (
                <SalaryAdjustments
                  {...this.state}
                  {...this.props}
                  setCurrentView={this.setCurrentView}
                />
              )}
            {page == "payrolloverview" && salarycycle && payrollcycle && (
              // && postdataforemplist
              <Overview
                {...this.state}
                {...this.props}
                getsalarycycledata={(id) => this.getsalarycycledata(id)}
                setCurrentView={this.setCurrentView}
              />
            )}
            {page == "payrollCompleted"
              && salarycycle
              && payrollcycle
              && postdataforemplist && (
                <PayrollCompleted
                  {...this.state}
                  {...this.props}
                  setCurrentView={this.setCurrentView}
                />
              )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  subscription: state.SubscriptionInfo.SubscriptionData,
  SaveInProgressReducer: state.SaveInProgressReducer,
  login: state.AuthenticationAction.login,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSaveProgress,
      removeSaveProgress,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withStyles(styles, { withTheme: true })(withSnackbar(RunPayroll)),
);
